<!-- title -->
<app-modal-title
  [title]="title + ' ' + scheduledMessageId"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <div *ngIf="deliveryStatusData.length > 0">
    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex tw-justify-center">
          <table
            class="table table-row-bordered tw-mt-3 bg-white"
            style="border-style: ridge"
          >
            <tr>
              <th class="tw-text-center tw-p-3 fw-bolder">
                {{ "common.status" | translate }}
              </th>
              <th class="tw-text-center tw-p-3 fw-bolder">
                {{ "common.count" | translate }}
              </th>
            </tr>
            <ng-container *ngFor="let item of deliveryStatusData">
              <tr>
                <td class="tw-text-center p-3">
                  {{
                    item.deliveryStatus | enumToText : DeliveryStatusEnumValues
                  }}
                </td>
                <td class="tw-text-center p-3">
                  {{ item.count | numberSeparator }}
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="chartData.length > 0">
    <app-base-doughnut-chart
      [chartId]="chartId"
      [labels]="labels"
      [data]="chartData"
      [colors]="colors"
    >
    </app-base-doughnut-chart>
  </div>
  <div style="padding: 50px !important" *ngIf="chartData.length == 0">
    <h4 class="tw-text-center tw-text-gray-700 dark:tw-text-gray-300">
      {{ "common.noDataFound" | translate }}
    </h4>
  </div>
</div>
